import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon, SafeHtml, openModalByName, requestResourceByName, useScopedSelector } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { StyledT, StyledP, StyledActions, StyledLink, StyledBackgroundDiv, StyledCloseButton } from './ContestContent.styles';
import { ContestResourceInfo } from '../ContestResource/ContestResource';
import { ContestInformation } from '../../../interfaces/ContestInformation';
import { ContestParticipation } from '../../../interfaces/ContestParticipation';
import ConfirmUnsubscribe from '../ConfirmUnsubscribe';
import { ContestParticipationResourceInfo } from '../ContestResource/ContestParticipationResource/ContestParticipationResource';

export interface ContestContentProps { }

const ContestContent: FC<ContestContentProps> = () => {
  const contest: ContestInformation = useScopedSelector(ContestResourceInfo.dataDst);
  const participation: ContestParticipation = useScopedSelector(ContestParticipationResourceInfo.dataDst);
  const resourcesPending = useScopedSelector('/App.contest.contestResources.pending');
  const { t } = useTranslation('Contest');
  const dispatch = useDispatch();

  const [hideContest, setHideContest] = useState<boolean>(false);

  useEffect(() => {
    if (contest?.isActive && participation?.isSubscribed) {
      dispatch(requestResourceByName('/App.contest.subscriptionEntriesResource'));
    }
  }, [participation, dispatch, contest?.isActive]);

  const showContest = !hideContest && !resourcesPending && contest?.isActive && (!participation || (participation.isSubscribed && !participation.isPostponed));

  if (showContest) {
    return (
      <>
        <ConfirmUnsubscribe onConfirm={() => setHideContest(true)} />
        <StyledBackgroundDiv data-testid="contestBanner">
          <StyledCloseButton
            data-testid="closeButton"
            Icon={CloseIcon}
            iconSize={18}
            onClick={() => {
              dispatch(requestResourceByName('/App.contest.reminderResource'));
              setHideContest(true);
            }}
            title={t('detailsModalClose')}
          />
          <>
            <StyledT data-testid="bannerTitle">{contest?.title}</StyledT>
            <StyledP>
              <SafeHtml data-testid="bannerSummary">{`${contest?.summary}`}</SafeHtml>
            </StyledP>
            <StyledActions>
              <StyledLink data-testid="detailsLink" onClick={() => dispatch(openModalByName('contestDetailsModal'))}>{t('detailsLink')}</StyledLink>
              <StyledLink data-testid="unsubscribeLink" onClick={() => dispatch(openModalByName('confirmUnsubscribe'))}>{t('unsubscribeLink')}</StyledLink>
            </StyledActions>
          </>
        </StyledBackgroundDiv>
      </>
    );
  }

  return null;
};

export default ContestContent;
